import React, { useContext, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "components/ui/Header";
import Page from "components/ui/Page";
import { Tab, Tabs } from "components/ui/Tabs";
import ProfileSettings from "../ClientCompany/components/ProfileSettings";
import NotificationSettings from "../Companies/components/NotificationSettings";
import PaymentSettings from "../ClientCompany/components/PaymentSettings";
import UserContext from "context/User";

export default function Settings() {
  const { user } = useContext<any>(UserContext);
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const activeTab = searchParams.get("tab") || "profile";

  const isClient = user?.accessLevel === "isClient" || user?.accessLevel === "isClientAdmin";

  const tabLinks = useMemo(() => {
    const links = [
      { key: "profile", label: "Profile" },
      { key: "notifications", label: "Notifications" },
    ];
    if (isClient) {
      links.push({ key: "payments", label: "Payments" });
    }
    return links;
  }, [isClient]);

  useEffect(() => {
    document.title = (process.env.REACT_APP_NAME || "JSCRM") + " | My Settings";
  }, []);

  // Guard: only valid tabs
  useEffect(() => {
    const validTabs = tabLinks.map((t) => t.key);
    if (!validTabs.includes(activeTab)) {
      navigate("/settings?tab=profile", { replace: true });
    }
  }, [activeTab, navigate, tabLinks]);

  return (
    <>
      <Header />
      <Page title="My Settings" subtitle="Manage your profile, notifications, and payment methods.">
        <Tabs
          vertical
          fillHeight
          links={tabLinks}
        >
          <Tab itemKey="profile">
            <ProfileSettings />
          </Tab>
          <Tab itemKey="notifications">
            <NotificationSettings />
          </Tab>
          {isClient && (
            <Tab itemKey="payments">
              <PaymentSettings />
            </Tab>
          )}
        </Tabs>
      </Page>
    </>
  );
}
